import type { ThemePort, Theme } from '../domain/theme'

const STORAGE_KEY = 'journ.theme:v1'
const themes = ['light', 'dark', 'system'] as const satisfies Theme[]

const isTheme = (value: string | null): value is Theme => value !== null && themes.includes(value as Theme)

const domThemeAdapter: ThemePort = {
	get(): Theme {
		try {
			const theme = localStorage.getItem(STORAGE_KEY)
			return isTheme(theme) ? theme : 'system'
		} catch {
			return 'system'
		}
	},

	set(theme: Theme): void {
		const isDark = theme === 'dark' || (theme === 'system' && window.matchMedia('(prefers-color-scheme: dark)').matches)

		document.documentElement.classList.toggle('dark', isDark)
		try {
			localStorage.setItem(STORAGE_KEY, theme)
		} catch {}
	},
}

export { domThemeAdapter }
